import React, { Component } from 'react';

import CoachLayout from './CoachLayout';
import CommonService from '../../services/commonService';
import DateService from '../../services/dateService';
import DropdownComponent from '../common/DropdownComponent';
import { KuposButton } from '../common';
import KuposSelectBox from '../common/KuposSelectBox';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import TrainCoachLayout from './TrainCoachLayout';
import getIcons from '../themes/functions/getIcons/getIcons';
import { isNull } from 'lodash';

export default class SelectedServiceMore extends Component {
  static propTypes = {
    boardingOptions: PropTypes.array,
    droppingOptions: PropTypes.array,
    selectedBoarding: PropTypes.object,
    selectedDropping: PropTypes.object,
    onBoardingPointChange: PropTypes.func,
    onDroppingPointChange: PropTypes.func,
    selectedService: PropTypes.object,
    onContinueButtonClick: PropTypes.func,

    metaData: PropTypes.object,
    coachLayout: PropTypes.array,
    upperAvalibility: PropTypes.bool,
    selectedSeatsToBook: PropTypes.array,
    onFloorChange: PropTypes.func,
    selectedFloor: PropTypes.any,
    onSeatSelect: PropTypes.func,
    bookingDetails: PropTypes.object,
    t: PropTypes.func,
    closeLayout: PropTypes.func,

    boardingErrorMessage: PropTypes.string,
    droppingErrorMessage: PropTypes.string,
  };

  seatTypeMouseoverDivEl = {};

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true);
    // console.log('selectedBoarding', this.props.selectedBoarding);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }

  handleClickOutside = event => {
    // cmmmented by tanveer not needed
    // const domNode = ReactDOM.findDOMNode(this);
    // if (!domNode || !domNode.contains(event.target)) {
    //   // console.log('clicked outside',event)
    //   this.props.closeLayout();
    // }
  };

  isSeatType = type => {
    // console.log('Seats bottom strip------------', type);
    if (CommonService.isTrain() || this.props.serviceDetails.travel_id == 272) {
      for (let wLayout of this.props.coachLayout) {
        for (let row of wLayout) {
          for (let seat of row) {
            // console.log('Seat is-----------------', seat);
            if (seat.type.toUpperCase() == type && seat.number.toUpperCase().indexOf('GY') < 0) {
              return true;
            }
          }
        }
      }
    } else {
      for (let row of this.props.coachLayout) {
        for (let seat of row) {
          if (seat.type.toUpperCase() == type && seat.number.toUpperCase().indexOf('GY') < 0) {
            return true;
          }
        }
      }
    }
    return false;
  };

  getSeatType = (text, icon) => {
    const operator = CommonService.getLocal('op');
    // let seatMessage =
    //   operator && operator.operator_name == 'cormarbus' && text == 'Salón Cama'
    //     ? 'Asientos con máximo 150° grados de inclinación.'
    //     : operator && operator.operator_name == 'cormarbus' && text == 'Premium'
    //     ? 'Asientos con máximo 180° grados de inclinación.'
    //     : text === 'Mascota a bordo'
    //     ? this.props.t('TRANSLATIONS.PET_SEAT_INFO')
    //     : 'Asientos con máximo 155° grados de inclinación.';

    let seatMessage;

    if (operator && operator.operator_name === 'cormarbus') {
      if (text === 'Salón Cama') {
        seatMessage = 'Asientos con máximo 150° grados de inclinación.';
      } else if (text === 'Premium') {
        seatMessage = 'Asientos con máximo 180° grados de inclinación.';
      } else {
        seatMessage = 'Asientos con máximo 155° grados de inclinación.';
      }
    }

    if (operator && operator.operator_name === 'andimar') {
      if (text === 'Salón Cama') {
        seatMessage = 'Asientos con máximo 160° grados de inclinación.';
      } else if (text === 'Semi Cama') {
        seatMessage = 'Asientos con máximo 130° grados de inclinación.';
      } else {
        seatMessage = 'Asientos con máximo 155° grados de inclinación.';
      }
    }


    else if (text === 'Mascota a bordo') {
      seatMessage = this.props.t('TRANSLATIONS.PET_SEAT_INFO');
    } else {
      seatMessage = 'Asiento disponibilizado para mascotas.';
    }

    console.log('text------',text);
    return (
      <div className="seat-type-icon">
        <style>
          .continue-button-row .seat-type-mouseover:before {'{'}
          border-top:19px solid{' '}
          {operator && operator.color_codes && operator.color_codes.secondary_color
            ? operator.color_codes.secondary_color
            : '#ff5c60'}
          ;{'}'}
        </style>
        <img src={icon} alt="" style={text === 'Mascota a bordo' ? { rotate: '-90deg' } : {}} />
        {text}
        <div
          className="mouseover-popups seat-type-mouseover"
          key={text + Math.random()}
          ref={el => {
            this.seatTypeMouseoverDivEl[text] = el;
          }}
          style={{
            marginLeft:
              '-' +
              (this.seatTypeMouseoverDivEl[text]
                ? this.seatTypeMouseoverDivEl[text].clientWidth / 2
                : 0) +
              'px',
          }}
        >
          <span className="font9 bold-text upper-case-text">{text}</span>
          {/* <span className="font9">Asientos con máximo 155° grados de inclinación.</span> */}
          <span className="font9">{seatMessage}</span>
        </div>
      </div>
    );
  };

  hasPetSeats = () => {
    if (this.props.petSeats) {
      if (Object.keys(this.props.petSeats).length > 0) {
        return true;
      }
    }
    return false;
  };

  render() {
    // console.log('Dropping stages ---------', this.props.droppingOptions);
    let { t } = this.props;
    let boardingOptions = [];
    // for (let op of this.props.boardingOptions) {
    //   console.log('Individual boarding points are ---------------', this.props.boardingOptions);
    //   let time = DateService.ampm(op.time);
    //   let labelRaw = op.name + time;
    //   boardingOptions.push({
    //     // id: op.id,
    //     value: labelRaw,
    //     // label: op.name ,
    //     label: labelRaw,
    //   });
    // }

    this.props.boardingOptions.map(op => {
      let labelRaw = op.name + ' - ' + op.time;
      // console.log('Lable row is', labelRaw);
      boardingOptions.push({
        // id: op.id,
        value: op.id,
        // label: op.name ,
        label: labelRaw,
      });
    });

    let droppingOptions = [];
    for (let op of this.props.droppingOptions) {
      let labelRaw = op.name + ' - ' + op.time;
      droppingOptions.push({
        value: op.id,
        // label: op.name ,
        label: labelRaw,
      });
    }
    // console.log('Dropping stages choosen---------', droppingOptions);
    let selectedBoarding = null;
    if (this.props.selectedBoarding) {
      selectedBoarding = {
        value: this.props.selectedBoarding.id,
        label: this.props.selectedBoarding.name + ' - ' + this.props.selectedBoarding.time,
      };
    }
    let selectedDropping = null;
    if (this.props.selectedDropping) {
      selectedDropping = {
        value: this.props.selectedDropping.id,
        label: this.props.selectedDropping.name + ' - ' + this.props.selectedDropping.time,
      };
    }

    // console.log(
    //   'Boarding Options',
    //   droppingOptions,
    //   this.props.selectedDropping,
    //   this.props.boardingOptions,
    // );

    // console.log('Boarding and dropping selected -------------', selectedBoarding, selectedDropping);
    const operator = CommonService.getLocal('op');
    return (
      <div className="pb-service-list-selected-service-more service-card-more-details">
        <div className="close-btn flex-row">
          <img onClick={this.props.closeLayout} src="/static/images/icons/close-window.svg" />
        </div>
        <div className="flex-row select-row">
          <div className="select-item font10">
            <span className="select-label font11">{t('RESULTS_PAGE.BOARDING_POINT')}</span>
            {/* <div className="select-box flex-row kupos-border">
                      <img className="icon-source" src="/static/images/icons/home/icon_source.png"/>
                      <span>Terminal de buses Carlos Oviedo</span>
                      <img className="icon-arrow" src="/static/images/icons/icon-arrow.png"/>
                  </div> */}
            <KuposSelectBox
              options={boardingOptions}
              selectedOption={
                boardingOptions.length > 0 &&
                this.props.selectedBoarding &&
                this.props.selectedBoarding.id
                  ? selectedBoarding
                  : null
              }
              // selectedOption={isNull(selectedBoarding) ? null : selectedBoarding}
              onChange={this.props.onBoardingPointChange}
              placeholder={t('RESULTS_PAGE.BOARDING_POINT3')}
              // icon={operator && operator.origin_icon ? operator.origin_icon : "/static/images/icons/home/icon_source.png"}
              icon={getIcons('Origin', operator)}
              height={44}
              readonly={true}
              error={this.props.boardingErrorMessage ? true : false}
              errorMessage={this.props.boardingErrorMessage}
              t={t}
              showAll={true}
              key={
                this.props.boardingOptions && this.props.boardingOptions.length
                  ? this.props.boardingOptions.length > 1
                    ? this.props.boardingOptions.length +
                      this.props.boardingOptions[1].id +
                      this.props.boardingOptions[1].time
                    : this.props.boardingOptions.length +
                      this.props.boardingOptions[0].id +
                      this.props.boardingOptions[0].time
                  : ''
              }
            />

            {/* <DropdownComponent
              onChange={this.props.onBoardingPointChange}
              placeholder={t('RESULTS_PAGE.BOARDING_POINT3')}
              options={boardingOptions}
              value={selectedBoarding}
              // disabled={this.props.match.params.id ? true : false}
              error={this.props.boardingErrorMessage ? true : false}
              errorMessage={this.props.boardingErrorMessage}
            /> */}
          </div>
          <div className="select-item font10">
            <span className="select-label font11">{t('RESULTS_PAGE.DROP_OFF_POINT')}</span>
            {/* <div className="select-box flex-row kupos-border">
                      <img className="icon-source" src="/static/images/icons/home/icon_source.png"/>
                      <span>Terminal de buses Carlos Oviedo</span>
                      <img className="icon-arrow" src="/static/images/icons/icon-arrow.png"/>
                  </div> */}
            <KuposSelectBox
              options={droppingOptions}
              selectedOption={droppingOptions.length > 0 ? selectedDropping : null}
              // selectedOption={selectedDropping}
              onChange={this.props.onDroppingPointChange}
              placeholder={t('RESULTS_PAGE.DROP_OFF_POINT3')}
              icon={getIcons('Destination', operator)}
              // icon={operator && operator.destination_icon ? operator.destination_icon : "/static/images/icons/home/icon_source2.png"}
              height={44}
              readonly={true}
              error={this.props.droppingErrorMessage ? true : false}
              errorMessage={this.props.droppingErrorMessage}
              key={
                this.props.droppingOptions && this.props.droppingOptions.length
                  ? this.props.droppingOptions.length > 1
                    ? this.props.droppingOptions.length +
                      this.props.droppingOptions[1].id +
                      this.props.droppingOptions[1].time
                    : this.props.droppingOptions.length +
                      this.props.droppingOptions[0].id +
                      this.props.droppingOptions[0].time
                  : ''
              }
              t={t}
            />
          </div>
        </div>
        {CommonService.isTrain() || this.props.serviceDetails.travel_id == 272 ? (
          <TrainCoachLayout
            metaData={this.props.metaData}
            coachLayout={this.props.coachLayout}
            upperAvalibility={this.props.upperAvalibility}
            selectedSeatsToBook={this.props.selectedSeatsToBook}
            onFloorChange={this.props.onFloorChange}
            selectedFloor={this.props.selectedFloor}
            onSeatSelect={this.props.onSeatSelect}
            selectedService={this.props.selectedService}
            t={t}
            serviceDetails={this.props.serviceDetails}
          />
        ) : (
          <CoachLayout
            metaData={this.props.metaData}
            coachLayout={this.props.coachLayout}
            upperAvalibility={this.props.upperAvalibility}
            selectedSeatsToBook={this.props.selectedSeatsToBook}
            onFloorChange={this.props.onFloorChange}
            selectedFloor={this.props.selectedFloor}
            onSeatSelect={this.props.onSeatSelect}
            selectedService={this.props.selectedService}
            t={t}
            petSeats={this.props.petSeats}
            isMot={this.props.isMot}
            motMaxSeatError={this.props.motMaxSeatError}
          />
        )}
        <div className="continue-button-row flex-row">
          <div className="flex-row seat-types dark-text font10">
            {this.isSeatType('CLASICO')
              ? this.getSeatType('Clásico', '/static/images/seats/icon-seat-legend_executive.png')
              : null}
            {this.isSeatType('EJECUTIVO')
              ? this.getSeatType('Ejecutivo', '/static/images/seats/icon-seat-legend_executive.png')
              : null}
            {this.isSeatType('SEMI CAMA')
              ? this.getSeatType('Semi Cama', '/static/images/seats/icon-seat-legend_semi-bed.png')
              : null}
            {this.isSeatType('PREMIUM')
              ? this.getSeatType('Premium', '/static/images/seats/icon-seat-legend_vip.png')
              : null}
            {this.isSeatType('SALON CAMA')
              ? this.getSeatType(
                  'Salón Cama',
                  '/static/images/seats/icon-seat-legend_salon-cama.png',
                )
              : null}
            {this.isSeatType('SALON SIN VENT')
              ? this.getSeatType(
                  'Salón Sin Vent',
                  '/static/images/seats/icon-seat-legend_salon-cama.png',
                )
              : null}
            {this.isSeatType('PREFERENTE')
              ? this.getSeatType('Preferente', '/static/images/seats/icon-seat-legend_vip.png')
              : null}

            {this.isSeatType('CAMA PREMIUM')
              ? this.getSeatType('Cama Premium', '/static/images/seats/icon-seat-legend_vip.png')
              : null}

            {this.hasPetSeats()
              ? this.getSeatType(
                  'Asiento Mascota',
                  '/static/images/seats/SanAndres-ResultPage-SeatPick-PetsOnBoard-Reserved.svg',
                )
              : null}
          </div>
          <div className="continue-button font12">
            <KuposButton
              disabled={
                !this.props.selectedSeatsToBook || this.props.selectedSeatsToBook.length <= 0
              }
              onClick={this.props.onContinueButtonClick}
            >
              {t('RESULTS_PAGE.CONTINUE') +
                ': ' +
                (this.props.bookingDetails
                  ? CommonService.currency(this.props.bookingDetails.netBookingAmount).split(',')[0]
                  : '')}{' '}
            </KuposButton>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/pb-service-list/SelectedServiceMore.js